import ApiMethods from "../../ApiManager/ApiMethods";

/*
  Per-client in-flight-request dedup for POST auth/client_bookings. PackageDetailsModal is
  freshly mounted every time it's opened (Members/index.js renders it conditionally), so in
  dev, React 18 StrictMode's mount-time double-invoke fires its bookings fetch twice, back to
  back, for the same client_id on every single open. There's no caching here (bookings/booking
  status change too often for a TTL cache to make sense, unlike packagesCatalogStore) — this
  only collapses truly concurrent requests for the same client into one shared promise.
*/
const inFlightByClientId = new Map();

export function fetchClientBookings(clientId) {
  if (inFlightByClientId.has(clientId)) return inFlightByClientId.get(clientId);
  const promise = ApiMethods.post("auth/client_bookings", { client_id: clientId }).finally(() => {
    inFlightByClientId.delete(clientId);
  });
  inFlightByClientId.set(clientId, promise);
  return promise;
}
